import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetsApi } from 'src/Services/API';

export const useFetchAssetDetails = () => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-asset-details', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      return (await assetsApi.assetsControllerFindOne(assetId)).data;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    enabled: !!assetId,
  });
};
